import { render, staticRenderFns } from "./TableMetadataSelectorMenu.vue?vue&type=template&id=34eb4173&scoped=true&"
import script from "./TableMetadataSelectorMenu.vue?vue&type=script&lang=js&"
export * from "./TableMetadataSelectorMenu.vue?vue&type=script&lang=js&"
import style0 from "./TableMetadataSelectorMenu.vue?vue&type=style&index=0&id=34eb4173&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eb4173",
  null
  
)

export default component.exports